<template>
  <v-container grid-list-xl text-xs-center>
    <v-layout  row wrap  >
      <v-flex md6>
            <span class="sr-dates">
               <label class="blackLabel">Start Date</label>
              <date-picker style="width: 400px !important;min-width: 200px !important;"
                id="dashDate" valueType="format" v-model="date" format="YYYY-MM-DD"
                @change="handleChange"  placeholder="Summary Start Date"  lang="en" >
              </date-picker>
            </span>
      </v-flex>
      <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
          <v-btn color="success" class="text-xs-right" @click.stop="fncUpdateDate()" style="float: right;" >Update</v-btn>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import DatePicker from "vue2-datepicker";
import {mapGetters} from "vuex";

export default {
  components: {
    DatePicker
  },
  name: "Modal_Quote_api_dates",
  data() {
    return {
      date: null,
    };
  },
  methods: {
    fncHideModal() {
      this.$store.commit('hideModal');
    },
    handleChange(dateObj)
    {
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      const hours = String(dateObj.getHours()).padStart(2, '0');
      const minutes = String(dateObj.getMinutes()).padStart(2, '0');
      const seconds = String(dateObj.getSeconds()).padStart(2, '0');

      this.date = `${year}-${month}-${day}`;

    },
    fncUpdateDate() {

      this.$store.dispatch({
        type: 'fncUpdateDate',
        date: this.date,
        quote_no: this.globalModalParams.quote.id
      })

      },
  }
  ,
  computed: {
    ...mapGetters([
      'objAuthorize',
      'globalModalParams'
    ]),

  },
  mounted() {
    this.date = this.globalModalParams.date
  }
}
</script>

<style scoped>

</style>
